import { render, staticRenderFns } from "./CadastroProdutoSazonal.vue?vue&type=template&id=08846b36&scoped=true"
import script from "./CadastroProdutoSazonal.vue?vue&type=script&lang=js"
export * from "./CadastroProdutoSazonal.vue?vue&type=script&lang=js"
import style0 from "./CadastroProdutoSazonal.vue?vue&type=style&index=0&id=08846b36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08846b36",
  null
  
)

export default component.exports